/**
 * Shared control styling for the App Settings editors.
 *
 * Extracted so the composite editors (business hours, product codes, email
 * senders) share one treatment rather than each re-deriving it — the design
 * system's rule is to reuse tokens, not invent per-surface greys and heights.
 */

// Switch reads as accent blue when on (matches the design-system accent).
export const SWITCH_ACCENT_SX = {
  '& .MuiSwitch-switchBase.Mui-checked': { color: '#4A90D9' },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: '#4A90D9',
  },
};

// Standard field treatment (FIELD_SX) compacted to a 30px control height so
// the inputs match the other form controls across the admin pages.
export const COMPACT_FIELD_SX = {
  '& .MuiOutlinedInput-root': {
    borderRadius: '6px',
    backgroundColor: '#fff',
    height: 30,
  },
  '& .MuiInputBase-input, & .MuiSelect-select': {
    fontSize: 14,
    color: '#1a1a1a',
    paddingTop: 0,
    paddingBottom: 0,
  },
  '& .MuiInputLabel-root': { color: '#646464' },
  '& .MuiInputLabel-root.Mui-focused': { color: '#4A90D9' },
  '& .MuiOutlinedInput-notchedOutline': { borderColor: '#d0dcea' },
  '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: '#c5d9f0',
  },
  '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: '#4A90D9',
  },
};
